import React from 'react';
import { FDPaper, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { StructuredContentItem } from 'Packages/FacetCore/Experimental/StructuredContentItem';

const contentIDMap = {
  header: 'WealthComHeader',
  howItWorks: 'WealthComHowItWorks',
  offering: 'WealthComOffering',
  simplicity: 'WealthComSimplicity',
  specificDocs: 'WealthComStateSpecificDocs',
  ongoingUpdates: 'WealthComOngoingUpdates',
  trustPackage: 'WealthComTrustPackage',
  willPackage: 'WealthComWillPackage',
};

export const EstatePlanningManagementPageStructuredContent = ({ collection }) => {
  const resourceMap = React.useMemo(() => {
    return collection.resources().list().reduce((acc, curr) => {
      acc[curr.id()] = curr;

      return acc;
    }, {});
  }, [collection]);

  const getStructuredContentItem = (contentId, props) => {
    const mapVal = resourceMap[contentId];

    return (mapVal) ? <StructuredContentItem {...props} structuredContentResource={mapVal} /> : null;
  };

  return (
    <FDPaper spacing={4} padding={4} appearance={'flat'}>
      <FDStack direction={'column'} spacing={10}>
        {getStructuredContentItem(contentIDMap.header)}
        {getStructuredContentItem(contentIDMap.howItWorks)}
        {getStructuredContentItem(contentIDMap.offering)}
        {getStructuredContentItem(contentIDMap.simplicity, { flipped: true })}
        <FDStack direction={'column'} spacing={6}>
          <FDStack wrap spacing={4}>
            {getStructuredContentItem(contentIDMap.specificDocs)}
            {getStructuredContentItem(contentIDMap.ongoingUpdates)}
          </FDStack>
          <FDStack wrap spacing={4}>
            {getStructuredContentItem(contentIDMap.trustPackage)}
            {getStructuredContentItem(contentIDMap.willPackage)}
          </FDStack>
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

EstatePlanningManagementPageStructuredContent.propTypes = {
  collection: PropTypes.object.isRequired,
};
